/* The touch homepage opens the dedicated catalogue; desktop links stay unchanged. */
(function () {
  'use strict';
  var touch = window.matchMedia('(max-width: 989px), (max-width: 1366px) and (pointer: coarse)');
  var originals = new Map();
  var observed = new WeakSet();

  function targetFor(link) {
    if (!link.matches('.asm-section-heading > a[href]') || link.getAttribute('aria-disabled') === 'true') return null;
    if (!/^hamısını\s+göstər|^hamısına\s+bax/i.test(link.textContent.trim())) return null;
    var block = link.closest('.asm-home-block');
    if (!block || !block.closest('.asm-home')) return null;
    // New/popular sections retain their existing destinations and paused policy.
    if (block.matches('#asm-new-products,[aria-labelledby="asm-new-products-title"],[aria-labelledby="asm-popular-products-title"]')) return null;
    if (!block.matches('[aria-labelledby="asm-all-products-title"]') && !block.querySelector('[data-asm-all-products-track]')) return null;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return null;
    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin || !/\/collections\/all\/?$/.test(url.pathname)) return null;
      var view = url.searchParams.get('view');
      if (view && view !== 'asm-catalog') return null;
      url.searchParams.set('view', 'asm-catalog');
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  }

  function updateLink(link) {
    if (!touch.matches) return;
    var target = targetFor(link);
    if (!target) return;
    if (!originals.has(link)) originals.set(link, { href: link.getAttribute('href'), children: Array.from(link.childNodes) });
    if (link.getAttribute('href') !== target) link.setAttribute('href', target);
    if (link.textContent !== 'Hamısına bax ›') link.textContent = 'Hamısına bax ›';
  }

  function updateHome(home) {
    if (touch.matches) home.querySelectorAll('.asm-section-heading > a[href]').forEach(updateLink);
    if (observed.has(home)) return;
    observed.add(home);
    new MutationObserver(function (changes) {
      if (!touch.matches) return;
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('a[href]')) updateLink(node);
          node.querySelectorAll('a[href]').forEach(updateLink);
        });
      });
    }).observe(home, { childList: true, subtree: true });
  }

  function ready(scope) {
    if (!touch.matches) {
      originals.forEach(function (previous, link) {
        if (!link.isConnected) return;
        link.setAttribute('href', previous.href);
        link.replaceChildren.apply(link, previous.children);
      });
      originals.clear();
    }
    scope = scope && scope.querySelectorAll ? scope : document;
    if (scope.matches && scope.matches('.asm-home')) updateHome(scope);
    scope.querySelectorAll('.asm-home').forEach(updateHome);
  }

  var changed = function () { ready(document); };
  if (touch.addEventListener) touch.addEventListener('change', changed);
  else if (touch.addListener) touch.addListener(changed);
  document.addEventListener('shopify:section:load', function (event) { ready(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ready(document); }, { once: true });
  else ready(document);
})();
